import { __rest, __assign } from 'tslib';
import React from 'react';
import { Checkmark } from '../../checkmark/Component.js';
import { OptionBase } from '../Component.js';

var styles = {"option":"select__option_1657p","disabled":"select__disabled_1657p","size-48":"select__size-48_1657p","size-56":"select__size-56_1657p","size-64":"select__size-64_1657p","size-72":"select__size-72_1657p","selected":"select__selected_1657p","highlighted":"select__highlighted_1657p","content":"select__content_1657p","textContent":"select__textContent_1657p"};
require('./index.css')

var OptionDesktop = function (_a) {
    var _b = _a.Checkmark, Checkmark$1 = _b === void 0 ? Checkmark : _b, props = __rest(_a, ["Checkmark"]);
    return (React.createElement(OptionBase, __assign({}, props, { mobile: false, Checkmark: Checkmark$1, styles: styles })));
};

export { OptionDesktop };
